export const usmle2EthicsModule = {
  id: "ethics",
  title: "Ethics/Communication",
  sections: [
    {
      type: "text",
      content:
        "Capacity requires understanding, appreciation, reasoning, and choice.",
    },
    {
      type: "question",
      text: "Best response to an angry patient?",
      options: ["Acknowledge feelings and listen", "Argue facts", "Ignore", "Leave room"],
      correct: 0,
      explanation: "Validate emotions and listen before problem-solving.",
    },
  ],
};
